"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CROSSTALKTIMEWINDOW = exports.CROSSTALKVELOCITYSCALE = exports.GLOBALTHRESHOLDMULT = exports.BARHIGHMULTS = exports.BARLOWMULTS = exports.BARHIGHMULT = exports.BARLOWMULT = exports.BARAVGHIGH = exports.BARAVGLOW = exports.BARAVGHIGHS = exports.BARAVGLOWS = exports.BARUPTHRESHOLDS = exports.BARDOWNTHRESHOLDS = exports.CALIBRATIONGAIN = exports.CALIBRATION = exports.VELOCITYOFFSETS = exports.RAWVELOCITY = exports.TARES = exports.UI = exports.MIDI = exports.FWREADY = exports.FIRMWAREVERSION = exports.USERCURVE = exports.BUTTONPRESETMODE = exports.BARGAIN = exports.BARGAINS = exports.GLOBALPARAM = exports.PRESETPARAM = exports.PRESETCHUNK = exports.PRESETEND = exports.PRESETBEGIN = void 0;
// event names
const PRESETBEGIN = 'presetbegin';
exports.PRESETBEGIN = PRESETBEGIN;
const PRESETEND = 'presetend';
exports.PRESETEND = PRESETEND;
const PRESETCHUNK = 'presetchunk';
exports.PRESETCHUNK = PRESETCHUNK;
const PRESETPARAM = 'presetparam';
exports.PRESETPARAM = PRESETPARAM;
const GLOBALPARAM = 'globalparam';
exports.GLOBALPARAM = GLOBALPARAM;
const BARGAINS = 'bargains';
exports.BARGAINS = BARGAINS;
const BARGAIN = 'bargain';
exports.BARGAIN = BARGAIN;
const BUTTONPRESETMODE = 'buttonpresetmode';
exports.BUTTONPRESETMODE = BUTTONPRESETMODE;
const USERCURVE = 'usercurve';
exports.USERCURVE = USERCURVE;
const FIRMWAREVERSION = 'firmwareversion';
exports.FIRMWAREVERSION = FIRMWAREVERSION;
const FWREADY = 'deviceready';
exports.FWREADY = FWREADY;
const MIDI = 'midi';
exports.MIDI = MIDI;
const UI = 'ui';
exports.UI = UI;
const TARES = 'tares';
exports.TARES = TARES;
const RAWVELOCITY = 'rawvelocity';
exports.RAWVELOCITY = RAWVELOCITY;
const VELOCITYOFFSETS = 'velocityoffsets';
exports.VELOCITYOFFSETS = VELOCITYOFFSETS;
const CALIBRATION = 'calibration';
exports.CALIBRATION = CALIBRATION;
const CALIBRATIONGAIN = 'calibrationgain';
exports.CALIBRATIONGAIN = CALIBRATIONGAIN;
const BARDOWNTHRESHOLDS = 'bardownthresholds';
exports.BARDOWNTHRESHOLDS = BARDOWNTHRESHOLDS;
const BARUPTHRESHOLDS = 'barupthresholds';
exports.BARUPTHRESHOLDS = BARUPTHRESHOLDS;
const BARAVGLOWS = 'baravglows';
exports.BARAVGLOWS = BARAVGLOWS;
const BARAVGHIGHS = 'baravghighs';
exports.BARAVGHIGHS = BARAVGHIGHS;
const BARAVGLOW = 'baravglow';
exports.BARAVGLOW = BARAVGLOW;
const BARAVGHIGH = 'baravghigh';
exports.BARAVGHIGH = BARAVGHIGH;
const BARLOWMULT = 'barlowmult';
exports.BARLOWMULT = BARLOWMULT;
const BARHIGHMULT = 'barhighmult';
exports.BARHIGHMULT = BARHIGHMULT;
const BARLOWMULTS = 'barlowmults';
exports.BARLOWMULTS = BARLOWMULTS;
const BARHIGHMULTS = 'barhighmults';
exports.BARHIGHMULTS = BARHIGHMULTS;
const GLOBALTHRESHOLDMULT = 'thresholdmult';
exports.GLOBALTHRESHOLDMULT = GLOBALTHRESHOLDMULT;
const CROSSTALKVELOCITYSCALE = 'crosstalkvelocityscale';
exports.CROSSTALKVELOCITYSCALE = CROSSTALKVELOCITYSCALE;
const CROSSTALKTIMEWINDOW = 'crosstalktimewindow';
exports.CROSSTALKTIMEWINDOW = CROSSTALKTIMEWINDOW;